import axios from 'axios'; // eslint-disable-line

// eslint-disable-next-line 
export const getFmsClientId = () => {
    return axios
        .get(`${window.GENESIS_CMS_API_URL}/v3/forms/bridgeId?orgId=${localStorage.getItem('OrganizationId')}&churchId=${localStorage.getItem('GivingChurchId')}&sessionId=${localStorage.getItem('SessionId')}`);
};
